export const bulkCalendarDrawer = {
  header: {
    eyebrow: "Sammelbearbeitung",
    title: "Sammelkalender",
    subtitle: "Mehrere Einheiten auf einmal schließen, öffnen oder anpassen.",
  },
  actions: {
    close: {
      label: "Tage schließen",
      hint: "Setzt eine manuelle Sperre und berücksichtigt Buchungen und Synchronisierung.",
    },
    open: {
      label: "Tage öffnen",
      hint: "Öffnet nur die ausgewählten Tage, der Rest der Sperre bleibt bestehen.",
    },
    price: {
      label: "Preis ändern",
      hint: "Aktualisiert den Übernachtungspreis für die gewählten Tage und Unterkünfte.",
    },
    minStay: {
      label: "Mindestaufenthalt",
      hint: "Legen Sie die Mindestnächte pro Tag gesammelt fest.",
    },
  },
  microcopy: {
    close: "Manuelle Sperre",
    open: "Teilweise Öffnung",
    price: "Preis pro Nacht",
    minStay: "Mindestnächte",
  },
  step1: {
    title: "Was anwenden",
    hintEmpty: "Wählen Sie eine Aktion, um zu starten.",
  },
  step2: {
    title: "Wo anwenden",
    selectedCount: "{selected} von {total} ausgewählt",
    selectVisible: "Sichtbare",
    selectAll: "Alle",
    clear: "Leeren",
    searchPlaceholder: "Unterkunft suchen…",
    empty: "Keine Unterkunft passt zu Ihrer Suche.",
  },
  step3: {
    title: "Zeitraum und Tage",
    datesInRange: "{count} Tag im Zeitraum | {count} Tage im Zeitraum",
    from: "Von",
    to: "Bis",
    presetAll: "Alle",
    presetWeekdays: "Mo–Fr",
    presetWeekend: "Wochenende",
  },
  step4: {
    closeReasonTitle: "Grund der Sperre",
    availabilityTitle: "Verfügbarkeit",
    closeReasonHint: "Optional, wird mit der Sperre gespeichert.",
    availabilityHint: "Der Verkauf wird gestoppt (Stop-Sell), die Verfügbarkeit bleibt erhalten. Ändern Sie sie nur, wenn Sie möchten.",
    closeCommentPlaceholder: "z. B. Wartung oder Eigennutzung",
    availabilityPlaceholder: "Zimmer im Verkauf (leer = beibehalten)",
    openAvailabilityHint: "Öffnet den Verkauf wieder. Geben Sie an, wie viele Zimmer angeboten werden (leer = aktuelle beibehalten).",
    availabilityPlaceholderOpen: "Zimmer im Verkauf",
  },
  ratePlan: {
    title: "Zu ändernder Tarif",
    hint: "Dieser Typ hat mehrere Tarife. Wählen Sie, auf welche {target} angewendet wird. Abgeleitete Tarife passen sich automatisch an.",
    targetPrice: "der Preis",
    targetMinStay: "der Mindestaufenthalt",
    default: "Standard",
    roomsCount: "{count} Zimmer | {count} Zimmer",
    multiUnitNote: "Es gilt für jedes Zimmer mit dem gewählten Tarif.",
    fallbackName: "Tarif",
  },
  price: {
    title: "Neuer Preis pro Nacht",
    hint: "Gilt für die gewählten Tage, Einheiten und Tarife.",
    mixedCurrencyWarning: "Wählen Sie nur Unterkünfte mit derselben Währung.",
    placeholder: "Wert",
    placeholderCurrency: "Wert in {currency}",
    hintPercent: "Erhöht oder senkt den Preis, den jede Nacht bereits hat.",
    modeGroupLabel: "Art der Preisänderung",
    modeFixed: "Fester Preis",
    modeFixedHint: "Derselbe Betrag in allen Nächten.",
    modePercent: "Prozentsatz",
    modePercentHint: "Bezogen auf den Preis jeder einzelnen Nacht.",
    modeAmount: "Betrag",
    modeAmountHint: "Auf jede Nacht auf- oder abschlagen.",
    amountPlaceholder: "z. B. 10",
    amountHint: "Wird auf den bisherigen Preis jeder Nacht addiert. Mit − wird es weniger.",
    percentPlaceholder: "z. B. 20",
    percentHint: "Jede Nacht wird aus ihrem eigenen Preis neu berechnet. Das Zeichen − senkt ihn (zwischen {min} % und {max} %).",
    toggleSign: "Zwischen Erhöhen und Senken wechseln",
    invalidPercent: "Geben Sie einen Prozentsatz zwischen {min} % und {max} % ein, der nicht 0 ist.",
  },
  minStay: {
    title: "Mindestaufenthalt",
    hint: "Mindestanzahl Nächte pro Tag.",
    placeholder: "z. B. 2",
  },
  summary: {
    empty: "Einheiten und Zeitraum wählen.",
    unitOne: "Einheit",
    unitMany: "Einheiten",
    dateOne: "Tag",
    dateMany: "Tage",
    ready: "{propertyCount} {propertyLabel} · {dateCount} {dateLabel} bereit zum Anwenden.",
    nightOne: "Nacht",
    nightMany: "Nächte",
    readyPriceFixed: "{propertyCount} {propertyLabel} · setzt {price} {currency} in {dateCount} {nightLabel}.",
    readyPricePlus: "{propertyCount} {propertyLabel} · erhöht {dateCount} {nightLabel} um {amount} {currency}.",
    readyPriceMinus: "{propertyCount} {propertyLabel} · senkt {dateCount} {nightLabel} um {amount} {currency}.",
    readyPriceUp: "{propertyCount} {propertyLabel} · erhöht den Preis von {dateCount} {nightLabel} um {percent} %.",
    readyPriceDown: "{propertyCount} {propertyLabel} · senkt den Preis von {dateCount} {nightLabel} um {percent} %.",
  },
  footer: {
    cancel: "Abbrechen",
    apply: "Änderungen anwenden",
    applying: "Wird angewendet…",
  },
  weekdays: {
    mon: { short: "M", long: "Montag" },
    tue: { short: "D", long: "Dienstag" },
    wed: { short: "M", long: "Mittwoch" },
    thu: { short: "D", long: "Donnerstag" },
    fri: { short: "F", long: "Freitag" },
    sat: { short: "S", long: "Samstag" },
    sun: { short: "S", long: "Sonntag" },
  },
  ownerBlockComment: "Vom Eigentümer gesperrt",
};
